import React from 'react';
import {
	Input,
	Select,
	Form,
	Modal,
	DatePicker,
	Upload,
	message,
	Button,
	Icon,
	Col,
	Row,
	Drawer,
	Descriptions,
	Badge,
	Statistic,
	List, Tag, Table
} from 'antd';
import moment from 'moment';
import { server } from "../config";

const OrderRepayDetail = (props) => {

	const { onCancel, visible, item } = props;

	//定义表头
	const columns = [{
		title: '序号',
		render: (text, record, index) => `${index + 1}`,
		key: 'xh',
		width: 30
	}, {
		title: '借款日期',
		dataIndex: 'loan_date',
		key: 'loan_date',
		render: (text) => (
			<div>

				{text.length > 0 ? <span>{moment(text).format('YYYY-MM-DD HH:mm')}</span> : null}
			</div>
		),
		width: 100
	}, {
		title: '还款时间',
		dataIndex: 'repay_date',
		key: 'repay_date',
		render: (text) => (
			<div>

				{text.length > 0 ? <span>{moment(text).format('YYYY-MM-DD HH:mm')}</span> : null}
			</div>
		),
		width: 100
	},
	// 如果有还款类型，就显示
	...(
		item.m_orderRepay?.length > 0 && item.m_orderRepay?.[0]?.hasOwnProperty("repay_type") ?
			[{
				title: '还款类型',
				dataIndex: 'repay_type',
				key: 'repay_type',
				render: (text) => {
					if (text === "03") {
						return "自主还款";
					} else if (text === "07") {
						return "批扣还款";
					} else if (text === "08") {
						return "公司代偿";
					} else if (text === "13") {
						return "线下还款";
					} else {
						return text; // 如果不是上述几种类型，原样显示
					}
				},
				width: 100
			}
			]
			:
			[]
	),
	{
		title: '本次还款本金加利息(元)',
		dataIndex: 'repay_amount',
		key: 'repay_amount',
		render : (text) =>( text===null?'':parseFloat(text)/100),
		width: 100
	}, {
		title: '借据金额(元)',
		dataIndex: 'loan_amount',
		key: 'loan_amount',
			render : (text) =>( text===null?'':parseFloat(text)/100),
		width: 100
	}, {
		title: '余额(元)',
		dataIndex: 'remain_loan_amount',
		key: 'remain_loan_amount',
			render : (text) =>( text===null?'':parseFloat(text)/100),
		width: 100
	},
	{
		title: '还款本金(元)',
		dataIndex: 'amount',
		key: 'amount',
		render : (text) =>(text===null?'':parseFloat(text)/100),
		width: 100
	},
	{
		title: '还款利息(元)',
		dataIndex: 'interest',
		key: 'interest',
		render : (text) =>( text===null?'':parseFloat(text)/100),
		width: 100
	},
	//  {
	// 	title: '是否推送sap',
	// 	dataIndex: 'repay_notice_res',
	// 	key: 'repay_notice_res',

	// 	width: 100
	// },
	];


	const tabelDefinition = {
		rowKey: 'id',
		columns: columns,
		dataSource: item.m_orderRepay,
		pagination: { hideOnSinglePage: true },
	}
	let width = window.innerWidth < 768 ? window.innerWidth * 0.8 : window.innerWidth * 0.55
	return (
		<Drawer title={<span>企信宝还款明细</span>} placement="right" closable={false} onClose={onCancel} visible={visible} width={width}  >
			{/*	<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.payee_list,null , 2)}<br/><br/><br/>
                  </pre></Col>
			</Row>*/}
			<Row>
				<Col span={24} style={{ margin: 0, textAlign: 'left' }}>
					<Table {...tabelDefinition} />
				</Col>
			</Row>


		</Drawer>

	)

}


export default OrderRepayDetail;
